// @ts-check
import {geohashForLocation} from 'geofire-common';
import {MapService} from '@/services/MapService';
import {BlockPlanGraphic} from './BlockPlanGraphic';

/**
 * @typedef {import('@/services/GraphicService/GraphicService').GraphicData} GraphicData
 * @typedef {import('../BlockPlanGraphic/BlockPlanGraphic').BlockPlanGraphicData & GraphicData} BlockPlanGraphicData
 */

/**
 * Creates a new Block Plan graphic from the given data.
 * @param {BlockPlanGraphicData} data
 * @return {BlockPlanGraphic}
 */
function createBlockPlanGraphic(data) {
  return new BlockPlanGraphic(data);
}

function createNewBlockPlan(type, callback) {
  const center = MapService.getMap().getCenter();
  const northSouth = center.lat();
  const eastWest = center.lng();
  const bounds = {north: northSouth, south: northSouth, east: eastWest, west: eastWest};
  const geohash = geohashForLocation([northSouth, eastWest]);

  const featureData = {
    bounds,
    geohash,
    displayFields: [],
    graphicData: {
      buildingType: type,
      featureType: `blockPlan-${type}`,
      center: center.toJSON(),
    },
  };

  callback(featureData);
}

export {
  createBlockPlanGraphic,
  createNewBlockPlan,
};
